// Runtime-API polyfills for PDF.js (pdfjs-dist v5, used via react-pdf).
//
// Vite's `build.target` already down-levels JS *syntax* for old browsers, but it
// does NOT add missing *runtime APIs*. PDF.js v5 calls a handful of newer APIs;
// on older browsers those are simply absent and PDF.js throws on load.
//
// The one that bites in practice is `Promise.withResolvers` (ES2024): missing in
// Chrome/Edge < 119, Firefox < 121, Safari < 17.4. Chrome 109 (the last build for
// Windows 7 / 8.1, still common on school computers) is a frequent offender - it
// surfaces as "TypeError: Promise.withResolvers is not a function" from pdf.mjs.
//
// Every polyfill below is FEATURE-DETECTED, so modern browsers keep their native
// implementation untouched. This file is imported on the main thread (main.jsx)
// and bundled into the PDF worker (pdfWorker.js), so both JS contexts are covered.

// Promise.withResolvers() - Chrome/Edge < 119, Firefox < 121, Safari < 17.4.
if (typeof Promise.withResolvers !== "function") {
  // Spec: a static method whose `this` is the constructor used to build the promise.
  Promise.withResolvers = function withResolvers() {
    let resolve;
    let reject;
    const promise = new this((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

// Array.prototype.at() - Chrome < 92, Firefox < 90, Safari < 15.4. PDF.js uses
// `.at(-1)`. Cheap, exact polyfill for the older long tail (Chrome 109 has it
// natively; this only matters for pre-2022 Firefox/Safari).
if (typeof Array.prototype.at !== "function") {
  Array.prototype.at = function at(index) {
    const len = this.length;
    let i = Math.trunc(index) || 0;
    if (i < 0) i += len;
    return i < 0 || i >= len ? undefined : this[i];
  };
}
